<template>
  <div class="div-table">
    <div class="columns is-gapless">
      <div class="column is-12 card-header has-text-centered">
        <strong class="is-size-7-touch">Overall Placement</strong>
      </div>
    </div>
    <div
      :options="{ useUrlFragment: false }"
    >
      <div
        v-for="(type,index) in player.totalPlacements"
        :id="type.code"
        :key="type.name"
      >
        <div class="columns is-gapless is-flex">
          <div class="column is-3">
            <div class="num num-first text-center">
              1
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,1) }}
            </span>
          </div>
          <div class="column is-3">
            <div class="num text-center">
              9
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,9) }}
            </span>
          </div>
        </div>
        <div class="columns is-gapless is-flex">
          <div class="column is-3">
            <div class="num num-second text-center">
              2
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,2) }}
            </span>
          </div>
          <div class="column is-3">
            <div class="num text-center">
              10
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,10) }}
            </span>
          </div>
        </div>
        <div class="columns is-gapless is-flex">
          <div class="column is-3">
            <div class="num num-third text-center">
              3
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,3) }}
            </span>
          </div>
          <div class="column is-3">
            <div class="num text-center">
              11
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,11) }}
            </span>
          </div>
        </div>
        <div class="columns is-gapless is-flex">
          <div class="column is-3">
            <div class="num text-center">
              4
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,4) }}
            </span>
          </div>
          <div class="column is-3">
            <div class="num text-center">
              12
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,12) }}
            </span>
          </div>
        </div>
        <div class="columns is-gapless is-flex">
          <div class="column is-3">
            <div class="num text-center">
              5
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,5) }}
            </span>
          </div>
          <div class="column is-3">
            <div class="num text-center">
              13
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,13) }}
            </span>
          </div>
        </div>
        <div class="columns is-gapless is-flex">
          <div class="column is-3">
            <div class="num text-center">
              6
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,6) }}
            </span>
          </div>
          <div class="column is-3">
            <div class="num text-center">
              14
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,14) }}
            </span>
          </div>
        </div>
        <div class="columns is-gapless is-flex">
          <div class="column is-3">
            <div class="num text-center">
              7
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,7) }}
            </span>
          </div>
          <div class="column is-3">
            <div class="num text-center">
              15
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,15) }}
            </span>
          </div>
        </div>
        <div class="columns is-gapless is-flex">
          <div class="column is-3">
            <div class="num text-center">
              8
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,8) }}
            </span>
          </div>
          <div class="column is-3">
            <div class="num text-center">
              16
            </div>
          </div>
          <div class="column is-3">
            <span class="has-text-weight-semibold is-size-8">
              {{ filterPlacements(index,16) }}
            </span>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    props: ['player', 'tournamentType'],
    data () {
      return {}
    },
    watch: {
    },
    methods: {
      filterPlacements (index, place) {
        for (let i = 0; i < this.player.totalPlacements[index].placements.length; i++) {
          if (+place === +this.player.totalPlacements[index].placements[i].place) {
            return this.player.totalPlacements[index].placements[i].count
          }
        }
        return 'None'
      }
    }
  }
</script>
